import { render } from "./Modal.vue?vue&type=template&id=449ebe4a&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=ts"
export * from "./Modal.vue?vue&type=script&lang=ts"

import "./Modal.vue?vue&type=style&index=0&id=449ebe4a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-449ebe4a"

export default script